import type {
  SupportContentKind,
  SupportDocument,
} from '../models/SupportLibrary';

export function filterSupportDocuments(
  documents: SupportDocument[],
  kind: SupportContentKind,
  tags: string[]
): SupportDocument[] {
  return documents.filter((document) => {
    const isVideo =
      document.sourceType === 'support-video' ||
      document.sourceType === 'support-video-private';
    return (
      (kind === 'all' || (kind === 'videos' ? isVideo : !isVideo)) &&
      (tags.length === 0 || tags.some((tag) => document.tags.includes(tag)))
    );
  });
}

export function getApprovedSupportUrl(
  sourceUrl?: string | null
): string | null {
  if (!sourceUrl) return null;
  try {
    const url = new URL(sourceUrl);
    return url.protocol === 'https:' && !url.username && !url.password
      ? url.href
      : null;
  } catch {
    return null;
  }
}

export function getYouTubeEmbedUrl(sourceUrl?: string | null): string | null {
  const approved = getApprovedSupportUrl(sourceUrl);
  if (!approved) return null;
  const url = new URL(approved);
  const host = url.hostname.toLowerCase().replace(/^(www\.|m\.)/, '');
  let videoId = '';
  if (host === 'youtu.be') {
    videoId = url.pathname.slice(1);
  } else if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    videoId =
      url.searchParams.get('v') ||
      (/^\/(embed|shorts)\/([A-Za-z0-9_-]{11})$/.exec(url.pathname)?.[2] ?? '');
  }
  return /^[A-Za-z0-9_-]{11}$/.test(videoId)
    ? `https://www.youtube-nocookie.com/embed/${videoId}`
    : null;
}
